import { Component, forwardRef } from '@angular/core';
import { PLATFORMS } from 'voxloud-types/dist/models/reviews';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gdp-select-platform',
  templateUrl: './select-platform.component.html',
  styleUrls: ['./select-platform.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectPlatformComponent),
      multi: true
    }
  ]
})
export class SelectPlatformComponent implements ControlValueAccessor {
  public PLATFORMS: string[] = PLATFORMS;
  public selectedPlatform: string = this.PLATFORMS[0];

  onChange: any = () => { }
  onTouch: any = () => { }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(val: string) {
    if (val) {
      this.selectedPlatform = val;
    }
  }

  public selectPlatform(platform: string) {
    this.selectedPlatform = platform;
    this.onChange(platform);
  }

}
